export const PERMISSION_ARTIST_ENTITY = 'App\\Artist'
export const PERMISSION_CATEGORY_ENTITY = 'App\\Category'
